import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../atoms/button';

const StyledButton = styled(Button)`
  margin-bottom: 1rem;
  outline: 0;
  padding: 0 1rem;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoint.large}) {
    margin-bottom: 0;
  }
`;

const RegistryButton = (props) => {
  const [hasVariantWithRegistry] = useState(!!props?.variants?.find((v) => v.is_registry));
  const [isRegistry, setIsRegistry] = useState(props.variant && props.variant.is_registry);

  const handleOnRegistryClick = () => {
    const { sku } = props.variant;
    global.window.open(`${process.env.NEXT_PUBLIC_JIFITI_HOST}/registered/login/${sku}/${props.quantity}`);
  };

  useEffect(() => {
    const variantCanBeAddedToRegistry = () => props.variant && props.variant.is_registry;

    setIsRegistry(variantCanBeAddedToRegistry);
  }, [props.variant]);

  if (hasVariantWithRegistry) {
    return (
      <StyledButton
        disabled={!(props.canSubmit && isRegistry)}
        onClick={handleOnRegistryClick}
        inverted
      >
        {
          isRegistry
            ? 'Add to Registry'
            : 'Registry Unavailable'
        }
      </StyledButton>
    );
  }
  return null;
};

RegistryButton.defaultProps = {
  variant: null,
  variants: []
};

RegistryButton.propTypes = {
  canSubmit: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  variants: PropTypes.array,
  variant: PropTypes.object,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default RegistryButton;
